import type { GoalsByMetric } from '../goalsByMetric';

export interface QuarterPoint {
  quarter: string;
  qoq?: Record<string, unknown>;
  yoy?: Record<string, unknown>;
}

export type RaceCategory = string;

export type GenderCategory = string;

export interface ParticipantsPoint extends QuarterPoint {
  participantsStarted: number;
}

export interface CompletionsPoint extends QuarterPoint {
  completed: number;
}

export interface AcademicCreditPoint extends QuarterPoint {
  creditYes: number;
  creditNo: number;
}

export interface SatisfactionPoint extends QuarterPoint {
  percentSatisfied: number | null;
}

export interface DemographicsPoint extends QuarterPoint {
  byRace: Record<RaceCategory, number>;
  byGender: Record<GenderCategory, number>;
}

export interface PlacementPoint extends QuarterPoint {
  placedInTulsa: number;
}

export interface ThecData {
  participants: ParticipantsPoint[];
  participantsAllTimeTotal: number;
  completions: CompletionsPoint[];
  completionsAllTimeTotal: number;
  academicCredit: AcademicCreditPoint[];
  academicCreditAllTime: { creditYes: number; creditNo: number };
  employerSatisfaction: SatisfactionPoint[];
  employerSatisfactionAllTimeAvg: number | null;
  participantSatisfaction: SatisfactionPoint[];
  participantSatisfactionAllTimeAvg: number | null;
  demographics: DemographicsPoint[];
  demographicsAllTime: {
    byRace: Record<RaceCategory, number>;
    byGender: Record<GenderCategory, number>;
  };
  placements: PlacementPoint[];
  placementsAllTimeTotal: number;
  tulsaPopulationPct: Record<RaceCategory, number>;
  goalsByMetric: GoalsByMetric;
}

/** Tulsa population share by race (reference data for parity comparison). */
export const TULSA_POPULATION_PCT: Record<RaceCategory, number> = {
  White: 58.0,
  Black: 15.0,
  'Hispanic/Latino': 17.0,
  Asian: 3.0,
  'Native American/Alaska Native': 4.65,
  'Pacific Islander': 0.2,
  Other: 2.15,
};
